import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useLocation,
  useParams,
  useHistory,
} from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../utils/init-firebase";
import Homepage from "../../pages/Homepage";
import InProgressPage from "../../pages/Loans/InProgressPage";
import Loginpage from "../../pages/Loginpage";
import PublicBookingPage, { LegacyBookingRedirect } from "../../pages/BookingPage/PublicBookingPage";
import PublicLeadFormPage from "../../pages/LeadForm/PublicLeadFormPage";
import NotfoundPage from "../../pages/NotfoundPage";
import Profilepage from "../../pages/Profile/Profilepage";
import ClientPage from "../../pages/Loans/ClientPage";
import SetupQueue from "../../pages/Loans/SetupQueue";
import AdminSettingsPage from "../../pages/AdminSettingsPage";
import CompletedSubmissionsPage from "../../pages/Loans/CompletedSubmissionsPage";
import NotSubmitted from "../../pages/Loans/NotSubmittedPage";
import TBDSubmissionsPage from "../../pages/Loans/TBDPage";
import ParkedPage from "../../pages/Loans/ParkedPage";
import MarketingRequestsList from "../../pages/Marketing/MarketingRequestsList";
import MarketingRequestPage from "../../pages/Marketing/MarketingRequestPage";
import { Layout } from "./Layout";
import MarketingVault from "../../pages/Marketing/MarketingVault";
import Logos from "../../pages/Marketing/Logos";
import MarketingSettings from "../../pages/Marketing/MarketingSettings";
import SubmissionSettings from "../../pages/Loans/SubmissionSettings";
import LoanReports from "../LoanReports/LoanReports";
import ApprovalLetterPage from "../../pages/ApprovalLetterPage";
import MarketingInventory from "../../pages/Marketing/MarketingInventory";
import SwagItem from "../MarketingSwagV2/SwagItem";
import MarketingSwag from "../../pages/Marketing/MarketingSwag";
import MarketingReports from "../MarketingReports/MarketingReports";
import OpsDashboardPage from "../../pages/OpsDashboardPage";
import MarketingSwagGuidelines from "../../pages/Marketing/MarketingSwagGuidelines";
import MonthlyNewsLetterPage from "../../pages/Marketing/MonthlyNewsletterPage";
import CompDashboardPage from "../../pages/CompDashboardPage";
import SocialMediaCompliance from "../../pages/Marketing/SocialMediaCompliance";
import SalesDashboardPage from "../../pages/SalesDashboardPage";
import MarketingDashboard from "../../pages/Marketing/MarketingDashboard";
import AllEditLogs from "../../pages/Loans/AllEditLogs";
import EscalationSettings from "../../pages/Escalations/EscalationSettings";
import EscalationPage from "../../pages/Escalations/components/EscalationPage";
import Escalations from "../../pages/Escalations/Escalations";
import MyDashboard from "../../pages/MyDashboard/MyDashboard";
import CalendarSettings from "../../pages/CalendarSettings/CalendarSettings";
import RecentSubmissionsPage from "../../pages/RecentSubmissions&Feedback/RecentSubmissionsPage";
import RecentFeedbackPage from "../../pages/RecentSubmissions&Feedback/RecentFeedbackPage";
import LenderMatrixPage from "../../pages/RecentSubmissions&Feedback/LenderMatrixPage";
import MarketingMatrixPage from "../../pages/Marketing/MarketingMatrixPage";
import BrokerDirectoryPage from "../../pages/BrokerDirectoryPage";
import ManageBrokerLicensesPage from "../../pages/ManageBrokerLicensesPage";
import ChatbotAnalyticsPage from "../../pages/Admin/ChatbotAnalyticsPage";
import LockDeskReportingPage from "../../pages/LockDesk/LockDeskReportingPage";
// Payroll (docs/Payroll/PLAN.md) — route only, intentionally absent from all
// sidebars/drawers/nav registries until Mitchell approves the feature.
import PayrollPage from "../../pages/Payroll/PayrollPage";
import OpsCommandCenter from "../../pages/OpsCommandCenter";
import SalesChallengePage from '../../pages/SalesChallengePage';
import SalesChallengeSettingsPage from '../../pages/SalesChallengeSettingsPage';
// Arive Pages
import AriveTestPage from '../../pages/AriveTestPage';
import AriveLoansPage from '../../pages/AriveLoansPage';
// DocAI Platform (hidden — navigate manually to /ai; SuperAdmin only, no nav entries)
import AIPlatformPage from '../../pages/AI/AIPlatformPage';
// Agents Portal (hidden — navigate manually to /agents; SuperAdmin only, no nav entries)
import AgentsPortalPage from '../../pages/Agents/AgentsPortalPage';
// Agent Studio (hidden — navigate manually to /assistants; per-user
// agentStudioEnabled flag only, NO SuperAdmin bypass, no nav entries)
import AssistantsHomePage from '../../pages/Assistants/AssistantsHomePage';
import AssistantBuilderPage from '../../pages/Assistants/AssistantBuilderPage';
import AssistantChatPage from '../../pages/Assistants/AssistantChatPage';
// CRM Pages
import CRMDashboardPage from '../../pages/CRM/DashboardPage';
import MyDealsPage from '../../pages/CRM/MyDealsPage';
import CRMCalendarPage from '../../pages/CRM/CalendarPage';
import AnalyticsPage from '../../pages/CRM/AnalyticsPage';
import CRMSettingsPage from '../../pages/CRM/SettingsPage';
import SignatureStudioPage from '../../pages/CRM/SignatureStudio/SignatureStudioPage';
import CRMIntegrationsPage from '../../pages/CRM/IntegrationsPage';
import QrStudioPage from '../../pages/CRM/QrStudioPage';
import CRMAdminPage from '../../pages/CRM/AdminPage';
import UsageBillingPage from '../../pages/CRM/UsageBillingPage';
import CrmApiKeysPage from '../../pages/CRM/ApiKeysPage';
import DealPage from '../../pages/CRM/DealPage';
import DealPageNotepadPOC from '../../pages/CRM/DealPageNotepadPOC'; // TEMP: POC route
import WorkspaceSearchPage from '../../pages/CRM/Workspace/WorkspaceSearchPage'; // PREVIEW: Person Workspace (allowlisted users only)
import PersonWorkspacePage from '../../pages/CRM/Workspace/PersonWorkspacePage'; // PREVIEW: Person Workspace (allowlisted users only)
import { CRMIdeasPage } from '../../pages/CRM/Ideas';
import NextLeadUpPage from '../../pages/CRM/NextLeadUpPage';
import MortgageMonitorPage from '../../pages/CRM/MortgageMonitorPage';
import LeaderboardPage from '../../pages/CRM/LeaderboardPage';
import CampaignsPage from '../../pages/CRM/Campaigns/CampaignsPage';
import MyMarketingPage from '../../pages/CRM/MyMarketing';
import NewsletterEditorPage from '../../pages/CRM/MyMarketing/NewsletterEditorPage';
import CampaignBuilderPage from '../../pages/CRM/Campaigns/Builder';
import { CampaignViewPage } from '../../pages/CRM/Campaigns/Builder';
import CampaignAnalytics from '../../pages/CRM/Campaigns/Analytics/CampaignAnalytics';
import TasksPage from '../../pages/Tasks/TasksPage';
import OAuthCallback from '../../pages/OAuthCallback';
import AgentConnectorAuthorizePage from '../../pages/AgentConnectorAuthorizePage';
// EOS Pages
import { RocksPage } from '../../pages/EOS/Rocks/RocksPage';
import { RocksDashboard } from '../../pages/EOS/Rocks/RocksDashboard';
import { IssuesPage } from '../../pages/EOS/Issues/IssuesPage';
import { ActionItemsPage } from '../../pages/EOS/ActionItems/ActionItemsPage';
import { CalendarPage } from '../../pages/EOS/Calendar/CalendarPage';
import { ScorecardPage } from '../../pages/EOS/Scorecard/ScorecardPage';
import { L10MeetingPage } from '../../pages/EOS/L10Meeting/L10MeetingPage';
import { CollaboratorsPage } from '../../pages/EOS/Collaborators/CollaboratorsPage';
import { WinsExcitedPage } from '../../pages/EOS/WinsExcited/WinsExcitedPage';
import { AdminPage } from '../../pages/EOS/Admin/AdminPage';
import PreferencesPage from '../../pages/EOS/Preferences/PreferencesPage';
import { VTOPage } from '../../pages/EOS/VTO/VTOPage';
import { AccountabilityChartPage } from '../../pages/EOS/AccountabilityChart/AccountabilityChartPage';
import { AIUsagePage } from '../../pages/EOS/AIUsage/AIUsagePage';
import { DashboardPage } from '../../pages/EOS/Dashboard/DashboardPage';
import { HistoricalRocksPage } from '../../pages/EOS/HistoricalRocks/HistoricalRocksPage';
import { HistoricalRockDetailPage } from '../../pages/EOS/HistoricalRocks/HistoricalRockDetailPage';
import { WeeklySummaryPage } from '../../pages/EOS/WeeklySummary/WeeklySummaryPage';
import { MeetingSummariesPage } from '../../pages/EOS/MeetingSummaries/MeetingSummariesPage';
import { NotificationsPage } from '../../pages/EOS/Notifications/NotificationsPage';
import { IdeasPage } from '../../pages/EOS/Ideas/IdeasPage';
import { MessagesPage } from '../../pages/EOS/Messages/MessagesPage';
import { CalendarSyncPage } from '../../pages/EOS/CalendarSync/CalendarSyncPage';
import { PolicyViewerPage } from '../../pages/EOS/PolicyViewer/PolicyViewerPage';
import SuperAdminRoute from './SuperAdminRoute';
import AgentStudioRoute from './AgentStudioRoute';
import EOSSuperAdminRoute from './EOSSuperAdminRoute';
import NewFeatureRoute from './NewFeatureRoute';
import WorkspacePreviewRoute from './WorkspacePreviewRoute';
import EOSUserRoute from './EOSUserRoute';
import { FutureBotProvider } from '../FutureBot/FutureBotProvider';
import FutureBotWidget from '../FutureBot/FutureBotWidget';
import { FeatureTourProvider } from '../FeatureTour/FeatureTourProvider';
import TourOverlay from '../FeatureTour/TourOverlay';
import { ContactDrawerProvider } from '../../contexts/ContactDrawerContext';
import { isExternalDemoUser, isDemoAllowedPath } from '../../utils/demoAccess';


export default function AppRouter(props) {
  const { SuperAdmin, currentUser } = useAuth();
  const [isFirstRender, setIsFirstRender] = React.useState(true);

  return (
    <>
      <Router>
        <FeatureTourProvider>
        <FutureBotProvider>
        {/* App-level contact drawer: lets task cards/modals slide the contact
            open on whatever page the user is on (must be inside the Router) */}
        <ContactDrawerProvider>
        <Switch>
          {/* Public Routes - No authentication needed */}
          <Route exact path="/login" component={Loginpage} />
          <Route exact path="/oauth/calendar/callback" component={OAuthCallback} />
          {/* OAuth 2.1 consent for the Origin Agent connector (ChatGPT etc.).
              Public route — the page handles Google sign-in inline so the
              OAuth query params survive untouched. */}
          <Route exact path="/oauth/authorize" component={AgentConnectorAuthorizePage} />
          {/* Public co-branded booking pages (FHL Scheduling) — borrowers reach these by link */}
          <Route exact path="/book/:handle/:slug" component={PublicBookingPage} />
          <Route exact path="/book/:slug" component={LegacyBookingRedirect} />
          {/* Public QR Studio lead-capture forms — visitors land here from fhl.one/q/{code} scans */}
          <Route exact path="/f/:slug" component={PublicLeadFormPage} />

          <Layout>
            <ProtectedRoute exact path="/" component={Homepage} />
            <ProtectedRoute exact path="/profile" component={Profilepage} />
            <ProtectedRoute exact path="/profile/:id" component={Profilepage} />
            <ProtectedRoute exact path="/admin" component={AdminSettingsPage} />
            <ProtectedRoute exact path="/admin/chatbot-analytics" component={ChatbotAnalyticsPage} />
            <ProtectedRoute exact path="/lock-desk-reporting" component={LockDeskReportingPage} />
            {/* Payroll — role-gated server-side (PayrollAdmin); no nav entry by design */}
            <ProtectedRoute exact path="/payroll" component={PayrollPage} />
            <ProtectedRoute
              exact
              path="/loan-reporting"
              component={LoanReports}
            />

            <ProtectedRoute exact path="/setup-queue" component={SetupQueue} />
            <ProtectedRoute
              exact
              path="/in-progress"
              component={InProgressPage}
            />
            <ProtectedRoute
              exact
              path="/in-progress/:id"
              component={ClientPage}
            />
            <ProtectedRoute exact path="/parked" component={ParkedPage} />
            <ProtectedRoute exact path="/parked/:id" component={ClientPage} />
            <ProtectedRoute exact path="/tbd" component={TBDSubmissionsPage} />
            <ProtectedRoute exact path="/tbd/:id" component={ClientPage} />
            <ProtectedRoute
              exact
              path="/completed"
              component={CompletedSubmissionsPage}
            />
            <ProtectedRoute
              exact
              path="/completed/:id"
              component={ClientPage}
            />
            <ProtectedRoute
              exact
              path="/not-submitted"
              component={NotSubmitted}
            />
            <ProtectedRoute
              exact
              path="/not-submitted/:id"
              component={ClientPage}
            />
            <ProtectedRoute exact path="/loans/:id" component={ClientPage} />
            <ProtectedRoute
              exact
              path="/all-edit-logs"
              component={AllEditLogs}
            />

            <ProtectedRoute
              exact
              path="/submission-settings"
              component={SubmissionSettings}
            />

            <ProtectedRoute
              exact
              path="/marketing-requests"
              component={MarketingRequestsList}
            />
            <ProtectedRoute
              exact
              path="/marketing-requests/:id"
              component={MarketingRequestPage}
            />
            <ProtectedRoute exact path="/swag" component={MarketingSwag} />
            <ProtectedRoute
              exact
              path="/marketing-matrix"
              component={MarketingMatrixPage}
            />

            <ProtectedRoute
              exact
              path="/social-media-compliance"
              component={SocialMediaCompliance}
            />
            <ProtectedRoute
              exact
              path="/marketing-inventory"
              component={MarketingInventory}
            />
            <ProtectedRoute
              exact
              path="/marketing-inventory/:name"
              component={SwagItem}
            />
            <ProtectedRoute
              exact
              path="/marketing-vault"
              component={MarketingVault}
            />
            <ProtectedRoute
              exact
              path="/marketing-reports"
              component={MarketingReports}
            />
            <ProtectedRoute
              exact
              path="/marketing-dashboard"
              component={MarketingDashboard}
            />
            <ProtectedRoute
              exact
              path="/marketing-settings"
              component={MarketingSettings}
            />
            <ProtectedRoute
              exact
              path="/marketing-swag-guidelines"
              component={MarketingSwagGuidelines}
            />
            <ProtectedRoute
              exact
              path="/monthly-newsletters"
              component={MonthlyNewsLetterPage}
            />
            <ProtectedRoute exact path="/logos" component={Logos} />

            <ProtectedRoute exact path="/escalations" component={Escalations} />
            <ProtectedRoute
              exact
              path="/escalations/:id"
              component={EscalationPage}
            />

            <ProtectedRoute
              exact
              path="/escalation-settings"
              component={EscalationSettings}
            />

            <ProtectedRoute
              exact
              path="/ops-dashboard"
              component={OpsDashboardPage}
            />
            <ProtectedRoute exact path="/ops-command-center" component={OpsCommandCenter} />
            <ProtectedRoute
              exact
              path="/sales-dashboard"
              component={SalesDashboardPage}
            />
            <ProtectedRoute exact path="/sales-challenge" component={SalesChallengePage} />
            <ProtectedRoute
              exact
              path="/comp-dashboard"
              component={CompDashboardPage}
            />
            <ProtectedRoute exact path="/sales-challenge-settings" component={SalesChallengeSettingsPage} />
            <ProtectedRoute
              exact
              path="/my-dashboard"
              component={MyDashboard}
            />

            <ProtectedRoute
              exact
              path="/my-dashboard/recent-submissions"
              component={RecentSubmissionsPage}
            />
            <ProtectedRoute
              exact
              path="/my-dashboard/recent-feedback"
              component={RecentFeedbackPage}
            />
            <ProtectedRoute
              exact
              path="/my-dashboard/lender-matrix"
              component={LenderMatrixPage}
            />

            <ProtectedRoute
              exact
              path="/my-dashboard/calendar-settings"
              component={CalendarSettings}
            />

            <ProtectedRoute
              exact
              path="/directory"
              component={BrokerDirectoryPage}
            />
            <ProtectedRoute
              exact
              path="/manage-broker-licenses"
              component={ManageBrokerLicensesPage}
            /> 

            {/* Arive Pages (not in sidebar - navigate manually) */}
            <SuperAdminRoute exact path="/arive-test" component={AriveTestPage} />
            <SuperAdminRoute exact path="/arive-loans" component={AriveLoansPage} />

            {/* DocAI Platform (hidden - navigate manually to /ai). Non-exact:
                the page's internal <Switch> owns /ai/documents/:id etc. */}
            <SuperAdminRoute path="/ai" component={AIPlatformPage} />

            {/* Agents Portal (hidden - navigate manually to /agents). Non-exact:
                the page's internal <Switch> owns /agents/runs/:id etc. */}
            <SuperAdminRoute path="/agents" component={AgentsPortalPage} />

            {/* Agent Studio (hidden - navigate manually to /assistants).
                Per-user agentStudioEnabled flag; SuperAdmin does NOT bypass. */}
            <AgentStudioRoute exact path="/assistants" component={AssistantsHomePage} />
            <AgentStudioRoute exact path="/assistants/:agentId/edit" component={AssistantBuilderPage} />
            <AgentStudioRoute exact path="/assistants/:agentId/chat" component={AssistantChatPage} />

            {/* CRM Routes */}
            <ProtectedRoute exact path="/crm" component={CRMDashboardPage} />
            <ProtectedRoute exact path="/crm/dashboard" component={CRMDashboardPage} />
            <ProtectedRoute exact path="/crm/contacts/:contactId" component={CRMDashboardPage} />
            <ProtectedRoute exact path="/crm/my-deals" component={MyDealsPage} />
            <ProtectedRoute exact path="/crm/deals/:dealId/notepad-poc" component={DealPageNotepadPOC} />
            {/* Person Workspace PREVIEW (allowlist-only; others redirect to dashboard) */}
            <WorkspacePreviewRoute exact path="/crm/workspace" component={WorkspaceSearchPage} />
            <WorkspacePreviewRoute exact path="/crm/workspace/:contactId" component={PersonWorkspacePage} />
            <ProtectedRoute exact path="/crm/deals/:dealId" component={DealPage} />
            <ProtectedRoute exact path="/crm/deals/:id" component={DealPage} />
            <ProtectedRoute exact path="/crm/calendar" component={CRMCalendarPage} />
            <ProtectedRoute exact path="/crm/analytics" component={AnalyticsPage} />
            <ProtectedRoute exact path="/crm/settings" component={CRMSettingsPage} />
            {/* Signature Studio (not in sidebar - navigate manually) */}
            <ProtectedRoute exact path="/crm/signature-studio" component={SignatureStudioPage} />
            {/* Pilot-gated (calSchedulingEnabled or CRM admin) — page redirects others */}
            <ProtectedRoute exact path="/crm/integrations" component={CRMIntegrationsPage} />
            {/* QR Studio — intentionally hidden (no sidebar/nav entry); direct URL only while testing */}
            <ProtectedRoute exact path="/crm/qr-studio" component={QrStudioPage} />
            <ProtectedRoute exact path="/crm/next-lead-up" component={NextLeadUpPage} />
            {/* CRM-membership gate (canAccessNewFeatures) — do not swap to ProtectedRoute */}
            <NewFeatureRoute exact path="/crm/mortgage-monitor" component={MortgageMonitorPage} />
            <NewFeatureRoute exact path="/crm/leaderboard" component={LeaderboardPage} />
            <ProtectedRoute exact path="/crm/campaigns" component={CampaignsPage} />
            <ProtectedRoute exact path="/crm/my-marketing" component={MyMarketingPage} />
            <ProtectedRoute exact path="/crm/my-marketing/newsletters/:newsletterId" component={NewsletterEditorPage} />
            {/* Builder is open to all users — ownership access is enforced
                in-page (personal campaigns only open for their creator or an
                admin impersonating the creator). */}
            <ProtectedRoute exact path="/crm/campaigns/builder" component={CampaignBuilderPage} />
            <ProtectedRoute exact path="/crm/campaigns/builder/:templateId" component={CampaignBuilderPage} />
            <ProtectedRoute exact path="/crm/campaigns/view/:templateId" component={CampaignViewPage} />
            <ProtectedRoute exact path="/crm/campaigns/analytics" component={CampaignAnalytics} />
            <SuperAdminRoute exact path="/crm/admin" component={CRMAdminPage} />
            <SuperAdminRoute exact path="/crm/admin/api-keys" component={CrmApiKeysPage} />
            {/* Usage & Billing — CRM Admins + SuperAdmins (page redirects everyone else) */}
            <ProtectedRoute exact path="/crm/usage" component={UsageBillingPage} />
            <SuperAdminRoute exact path="/crm/ideas" component={CRMIdeasPage} />

            {/* Tasks Route */}
            <ProtectedRoute exact path="/tasks" component={TasksPage} />

            {/* EOS Routes */}
            {/* Admin routes are protected by EOSSuperAdminRoute - requires BOTH SuperAdmin AND isEOSUser */}
            <EOSSuperAdminRoute
              exact
              path="/eos/admin"
            >
              <AdminPage />
            </EOSSuperAdminRoute>
            <EOSSuperAdminRoute
              exact
              path="/eos/ai-usage"
            >
              <AIUsagePage />
            </EOSSuperAdminRoute>

            {/* All other EOS routes are protected by EOSUserRoute */}
            <EOSUserRoute
              exact
              path="/eos/dashboard"
            >
              <DashboardPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/rocks"
            >
              <RocksPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/rocks-dashboard"
            >
              <RocksDashboard />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/historical-rocks"
            >
              <HistoricalRocksPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/historical-rocks/:rockId"
            >
              <HistoricalRockDetailPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/issues"
            >
              <IssuesPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/action-items"
            >
              <ActionItemsPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/calendar"
            >
              <CalendarPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/scorecard"
            >
              <ScorecardPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/l10"
            >
              <L10MeetingPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/meeting-summaries"
            >
              <MeetingSummariesPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/collaborators"
            >
              <CollaboratorsPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/wins-excited"
            >
              <WinsExcitedPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/weekly-summary"
            >
              <WeeklySummaryPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/notifications"
            >
              <NotificationsPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/ideas"
            >
              <IdeasPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/messages"
            >
              <MessagesPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/preferences"
            >
              <PreferencesPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/vto"
            >
              <VTOPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/accountability-chart"
            >
              <AccountabilityChartPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/calendar-sync"
            >
              <CalendarSyncPage />
            </EOSUserRoute>
            <EOSUserRoute
              exact
              path="/eos/policy-viewer"
            >
              <PolicyViewerPage />
            </EOSUserRoute>

            {/*     <TrainingLayout>
                  <ProtectedRoute exact path='/training' component={TrainingHome}/>
                  <ProtectedRoute exact path='/training/:slug' component={TrainingPage}/>
              </TrainingLayout>   */}
          </Layout>

          <ProtectedRoute exact path="*" component={NotfoundPage} />
        </Switch>
        <FutureBotWidget />
        <TourOverlay />
        </ContactDrawerProvider>
        </FutureBotProvider>
        </FeatureTourProvider>
      </Router>
    </>
  );
}

export function ProtectedRoute(props) {
  const { currentUser, Roles, loading, isFirstRender, setIsFirstRender } =
    useAuth();
  const { id } = useParams();
  const { path } = props;
  const history = useHistory();
  const location = useLocation();

  // A signed-in user whose Firestore doc has no `Roles` field would make
  // Roles.includes() throw a TypeError — and with no error boundary above,
  // that's a white screen right after the loading astronaut.
  const safeRoles = Roles || [];

  function handleRedirect(route) {
    setIsFirstRender(false);
    return <Redirect to={location.state?.from ?? route} />;
  }

  function handleRoute() {
    setIsFirstRender(false);
    return <Route {...props} />;
  }

  // External demo accounts (externalDemo === true) are confined to Origin:
  // any URL outside the demo allowlist bounces to /crm. Strictly opt-in —
  // for every regular user this is a no-op. See src/utils/demoAccess.js.
  if (
    currentUser &&
    isExternalDemoUser(currentUser) &&
    !isDemoAllowedPath(location.pathname)
  ) {
    return <Redirect to="/crm" />;
  }

  if (path === "/login") {
    return currentUser ? (
      safeRoles.includes("Loan Officer") ||
        safeRoles.includes("Mortgage Broker") ||
        safeRoles.includes("IT Team Lead") ? (
        handleRedirect("/my-dashboard")
      ) : (
        handleRedirect("/")
      )
    ) : (
      <Route {...props} />
    );
  }

  return currentUser ? (
    location.pathname === "/" &&
      (safeRoles.includes("Loan Officer") ||
        safeRoles.includes("Mortgage Broker") ||
        safeRoles.includes("IT Team Lead")) &&
      isFirstRender ? (
      handleRedirect("/my-dashboard")
    ) : (
      handleRoute()
    )
  ) : (
    <Redirect
      to={{
        pathname: "/login",
        state: { from: location.pathname },
      }}
    />
  );
}

/**
 * Role-based Protected Route
 * Checks if the current user has the required role before allowing access.
 * Fetches the user document from Firestore to check the role property.
 */
export function RoleProtectedRoute({ requiredRole, ...props }) {
  const { currentUser } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!currentUser?.uid) {
        setLoading(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          // Check for role in the EOS users collection structure
          // The role might be in the user document or we need to check the EOS users collection
          setUserRole(userData.role || null);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user role:', error);
        setLoading(false);
      }
    };

    fetchUserRole();
  }, [currentUser]);

  if (loading) {
    return null; // Or return a loading spinner
  }

  if (!currentUser) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: location.pathname },
        }}
      />
    );
  }

  if (userRole !== requiredRole) {
    return <Redirect to="/" />;
  }

  return <ProtectedRoute {...props} />;
}
